
import Vue from "vue";

export default Vue.extend({
  components: {
    TabMenu: () => import("@/components/TabMenu/TabMenu.vue"),
    ActivitiesView: () =>
      import("@/components/ActivitiesView/ActivitiesView.vue"),
    ActivitiesTimelineItem: () =>
      import("@/components/ActivitiesView/ActivitiesTimelineItem.vue"),
    ActivitiesTimelineItemAll: () =>
      import("@/components/ActivitiesView/ActivitiesTimelineItemAll.vue")
  },
  data: function() {
    return {
      showActivities: false,
      selectedTabKey: "edit",
      selectedTabKeyView: "view"
    };
  },
  methods: {
    onTabItemClick(key: string): void {
      if (key === "activities") {
        this.showActivities = true;
      } else {
        this.showActivities = false;
      }
      this.selectedTabKey = key;
      this.selectedTabKeyView = key;
    }
  },
  mounted() {
    const activeTab = this.$route.query?.activeTab;
    if (activeTab === "activities") {
      this.onTabItemClick("activities");
    }
  },
  computed: {
    menuItems() {
      return [
        {
          text: "Edit",
          key: "edit"
        },
        {
          text: "Activities",
          key: "activities"
        }
      ];
    },
    viewPageMenuItems() {
      return [
        {
          text: "View",
          key: "view"
        },
        {
          text: "Activities",
          key: "activities"
        }
      ];
    }
  }
});
